import { addTranslations } from "../../../translations/language-provider/translations";
// todo - remove everything that comes from outside the lib folder(manage somehow)

const messages = {
  contentManagement: "Content Management",
  emailTemplates: "Email Templates",
  customTexts: "Custom Texts",
  pacients: "Patients",
  prescribers: "Prescribers",
  companies: "Companies",
  questionnairesMenu: "Questionnaires",
  questionsMenu: "Questions",
  usersMenu: "Users",
  otherMenu: "Other",
  answersMenu: "Answer Options",
  answerQuestionnaireMenu: "Answer Questionnaire",
  new: "New",
  criteriaMenu: "Criteria",
  criteriaUsageMenu: "Criteria Usage",
  metaSkillMenu: "Meta Skills",
  principleMenu: "Principles",
  algorithmMenu: "Main Algorithm",
  invitesMenu: "Invitations",
  elementMenu: "Elements",
  feelingsMenu: "Feelings",
  organsMenu: "Organs",
  outputMenu: "Outputs",
  attributesMenu: "Attributes",
  inputMenu: "Inputs",
  secondaryAlgorithmMenu: "Secondary Algorithm",
  naturalElementMenu: "Natural Elements",
  seasonMenu: "Seasons",
  characterMenu: "Characters",
  answerComponentMenu: "Components",
  mobileApkMenu: "Mobile Apps",
  criteriaManagementMenu: "Criteria Management",
  apkMenu: "APK",
  textConfigMenu: "Text Config",
  algorithmOutputMenu: "Algorithm Output",
  generalOutputMenu: "General Output",
  highlightMenu: "Highlights",
  highlightTypeMenu: "Highlight Types",
  highlightOutputMenu: "Outputs",
  dailyChallengeMenu: "Daily Challenge",
  staticStringMenu: "Static Strings",
  userBackofficeMenu: "Backoffice Users",
  companyUsersMenu: "Company users",
  userAppMenu: "App Users",
  analysis: "Analysis",
  editableValues: "Editable Values",
  settingsMenu: "Settings",
  configurationMenu: "Configuration",
  advancedMenu: "Advanced",
  welcome: "Welcome",
  welcome_back_name: "Welcome back, {name}",
  welcome_subtitle:
    "Here is a quick overview of the last 30 days and shortcuts to common tasks.",
  metrics_last_30_days: "Last 30 days",
  analyses: "Analyses",
  completed_of: "{completed} completed of {total}",
  invitations_sent: "Invitations sent",
  reports_sent: "Reports sent",
  new_patients: "New patients",
  new_prescribers: "New prescribers",
  quick_access: "Quick access",
  reports: "Reports",
  search_placeholder: "Search patients, analyses, pages…",
  search_pages: "Pages",
  search_patients: "Patients",
  search_prescribers: "Prescribers",
  search_analyses: "Analyses",
  search_invitations: "Invitations",
  search_no_results: "No results found",
  page_desc_welcome: "Overview and key metrics for the last 30 days",
  page_desc_history: "View and manage recent analyses and their status",
  page_desc_questionnaire:
    "Start an analysis, create invitations, or pre-pay a questionnaire",
  page_desc_invites: "Browse invitations and resend emails",
  page_desc_pacients: "View and manage patient accounts",
  page_desc_prescribers: "View and manage prescriber accounts",
  page_desc_companies: "View and manage companies, platform fees, and Stripe status",
  page_desc_users_backoffice: "Manage admins and consultants with backoffice access",
  page_desc_users_app: "Manage users with mobile app access",
  page_desc_reports: "Edit report content, texts, and options",
  page_desc_email_templates: "Manage email content templates",
  page_desc_custom_texts: "Manage custom system texts",
  page_desc_push_notifications: "Manage push notification content",
  page_desc_settings: "Configure system constants and editable values",
  page_desc_questionnaires: "Create and manage questionnaires",
  page_desc_questions: "Create and manage questions",
  page_desc_answer_options: "Create and manage answer options",
  page_desc_gallery: "Browse and upload gallery images",
  page_desc_criteria: "Manage algorithm criteria",
  page_desc_criteria_usage: "Manage how criteria are used in the algorithm",
  page_desc_meta_skill: "Manage meta skills",
  page_desc_principle: "Manage principles",
  page_desc_algorithm_config: "Configure algorithm settings",
  page_desc_element: "Manage algorithm elements",
  page_desc_feeling: "Manage feeling attributes",
  page_desc_organ: "Manage organ attributes",
  page_desc_season: "Manage season attributes",
  page_desc_natural_element: "Manage natural element attributes",
  page_desc_character: "Manage character attributes",
  page_desc_input: "Manage algorithm inputs",
  page_desc_algorithm_output: "Manage algorithm outputs",
  page_desc_general_output: "Manage general outputs",
  page_desc_mobile_apps: "Manage mobile applications",
  page_desc_criteria_management: "Manage criteria management settings",
  prescriber_dashboard: "My Prescriber Dashboard",
  page_desc_prescriber_dashboard:
    "Prescribe analyses and follow your own invitations, as in the backoffice",
};

addTranslations("en-US", messages);

export default messages;
